module.exports = __webpack_public_path__ + "img/1546095066.7f2c4352.jpg";